<div style="padding: 20px;">
    <div class="table-card">
        <div class="table-header">
            <h2 class="table-title">{{ formatText(subMenu) }}</h2>
            <mat-form-field appearance="outline" class="custom-seash-input">
                <mat-label>Search</mat-label>
                <input matInput (keyup)="applyFilter($event)" [placeholder]="formatText(subMenu)" />
            </mat-form-field>
            <button mat-flat-button color="primary" class="reset-btn" 
                [disabled]="count == 0"
                [matMenuTriggerFor]="exportMenu">
                <mat-icon class="export-icon">download</mat-icon>
                Export
            </button>
            <mat-menu #exportMenu="matMenu" class="export-menu">
                <button mat-menu-item (click)="ExportTOExcel()" class="export-option">
                    <mat-icon class="option-icon">table_chart</mat-icon>
                    <span>Export as Excel (.xlsx)</span>
                </button>
                <button mat-menu-item (click)="exportToCSV()" class="export-option">
                    <mat-icon class="option-icon">description</mat-icon>
                    <span>Export as CSV (.csv)</span>
                </button>
                <button mat-menu-item (click)="exportToTxt()" class="export-option">
                    <mat-icon class="option-icon">text_snippet</mat-icon>
                    <span>Export as Text (.txt)</span>
                </button>
            </mat-menu>
        </div>
        <mat-divider style="margin-bottom: 10px;"></mat-divider>
        <table mat-table matSort [dataSource]="dataSource" class="workorder-table">
            <ng-container matColumnDef="OrganizationCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization Code</th>
                <td mat-cell *matCellDef="let report">
                    {{ report.OrganizationCode }}
                </td>
            </ng-container>
            <ng-container matColumnDef="OrganizationName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization Name</th>
                <td mat-cell *matCellDef="let report">
                    {{ report.OrganizationName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="ContactName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</th>
                <td mat-cell *matCellDef="let report">
                    {{ report.ContactName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Phone">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                <td mat-cell *matCellDef="let report">
                    {{ report.Phone }}
                </td>
            </ng-container>
            <ng-container matColumnDef="UsersEmail">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let report">
                    {{ report.UsersEmail }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                <td mat-cell *matCellDef="let report">
                    {{ report.Address }}
                </td>
            </ng-container>
            <ng-container matColumnDef="ActiveInactive">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Active/Inactive</th>
                <td mat-cell *matCellDef="let report">
                    {{ report.ActiveInactive }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <ng-container *ngIf="count == 0 || dataSource?.data.length === 0">
            <div class="no-records">No records found.</div>
        </ng-container>
        <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
    </div>
</div>